import { useState, useEffect } from 'react';
import { auctionApi } from '@/utils/api';
import { useStore } from '@/store/useStore';
import { CardRenderer } from '@/components/Cards/CardRenderer';
import { SkeletonCard } from '@/components/Feedback/SkeletonCard';
import { Gavel } from 'lucide-react';

export const MyBidsTab = ({ onNavigate }: { onNavigate: (path: string, payload?: any) => void }) => {
    const { user } = useStore();
    const [bids, setBids] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user?.telegram_id) return;
        setLoading(true);
        auctionApi.getActive(user.telegram_id, 'my_bids')
            .then(res => res.json())
            .then(data => {
                if (data.success && data.auctions) {
                    setBids(data.auctions);
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [user?.telegram_id]);

    if (loading) {
        return (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 px-4 mt-6">
                {[...Array(4)].map((_, i) => <SkeletonCard key={i} />)}
            </div>
        );
    }

    if (bids.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-20 opacity-50 px-4 text-center mt-6">
                <Gavel size={48} className="mb-4 text-white/30" />
                <h3 className="text-lg font-bold text-white mb-2">No Active Bids</h3>
                <p className="text-sm text-white/60 max-w-[250px]">You are not participating in any active auctions at the moment.</p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 px-4 mt-6">
            {bids.map(item => (
                <CardRenderer 
                    key={item.id} 
                    {...item}
                    context="auction" 
                    variant="premium"
                    showCardIcon={true}
                    compactOwner={true}
                    onInteract={() => onNavigate('auction_bid', item.id)} 
                />
            ))}
        </div>
    );
};
